/* eslint-disable */
/* eslint-disable camelcase */
// import core & vendor packages below
import moment from 'moment';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button, OverlayTrigger, Popover, Row, Col } from 'react-bootstrap';

// import components below
import Status from 'constant/status';
import { patientStatus, } from 'helpers';
import Table from 'components/ReactTable';
import TablePagination from './Pagination';
import TableUI from 'components/UI/TableUI';
import Tabs from 'constant/medicalRecordTabs';
import { showActivePatients, selectActivePatients } from 'reducers/medicalRecordReducer';

// import assets below
import { ReactComponent as EyeSVG } from 'assets/svg/eye.svg';
import { ReactComponent as ThreeDotsSVG } from 'assets/svg/three-dots-svgrepo-com.svg';


// main component
const ArchiveTable = ({ state, setState, setShowScreen, showProfile, setShowProfile }) => {

  const tableColumns = React.useMemo(
    () => [
      { Header: 'Date/Time Admitted', accessor: 'date' },
      { Header: 'Patient ID', accessor: 'id' }, // accessor is the "key" in the data
      { Header: 'Patient Name', accessor: 'name' },
      { Header: 'Room / Bed', accessor: 'room' },
      { Header: 'Age / Sex', accessor: 'ageSex' },
      { Header: 'Status', accessor: 'status' },
    ],
    []
  )

  const tableData = React.useMemo(
    () => state && state?.map(item => ({
      date: moment(item.createdAt).format('MMMM DD, YYYY hh:mm A'),
      id: item?.id,
      name: item?.full_name,
      room: item?.assigned_room ? item?.assigned_room?.room?.floor + ' floor / room # ' + item?.assigned_room?.room?.room : '-',
      ageSex: item?.age + ' / ' + item.sex,
      status: patientStatus(item?.patient_status),
    })),
    [state]
  )

  const handleTableAction = (eventKey, id) => {
    setShowScreen(1);
    setShowProfile({
      profileId: id,
    })
  }

  return (
    <div className='archive-table'>
      <Table
        data={tableData}
        columns={tableColumns}
        actions={{ hasProfile: true }}
        onAction={handleTableAction}
        pagination={['BOTTOM']}
      />
    </div>
  );
};

ArchiveTable.defaultProps = {
  state: [],
  setState: () => { },
  setShowScreen: () => { },
};

ArchiveTable.propTypes = {
  state: PropTypes.array,
  setState: PropTypes.func,
  setShowScreen: PropTypes.func,
};

export default ArchiveTable;
